var _circle, _path, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLatestEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.6668,
    r: 20,
    fill: "#CED2E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0697 23.1838L20.2226 29.8921L14.9371 23.1422C14.9371 23.1422 14.9371 23.1422 14.937 23.1421C12.1529 19.5853 12.2476 15.4375 14.8061 12.9556C16.1858 11.6208 18.0604 10.8667 20.02 10.8667C21.9797 10.8667 23.8543 11.6209 25.2339 12.9557C26.7878 14.4631 27.2645 16.259 27.1059 18.0607C26.9491 19.8417 26.1666 21.628 25.156 23.0643L25.0697 23.1838Z",
    stroke: "black",
    strokeWidth: 1.73333
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0013,
    cy: 17.7969,
    r: 2.46667,
    stroke: "black",
    strokeWidth: 1.73333
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatestEvent);
export default __webpack_public_path__ + "static/media/latest-event.a2640db3121712c6adeae73d8aed8a59.svg";
export { ForwardRef as ReactComponent };